import React from 'react';
import i18n from '../../../../../i18n';
import { makeStyles } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';

import { Dialog } from 'components/Dialog/Dialog';

export interface StepsExpandedParams {
    onClose: () => void;
}

const useStyles = makeStyles(theme => ({
    container: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
    title: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
}));

export const StepsExpanded = (params: StepsExpandedParams) => {
    const { t } = i18n.useTranslation();
    const classes = useStyles();
    return (
        <Dialog width={640} onClose={params.onClose} title={t('vendor:dashboard.stepsWidget.title')}>
            <div className={classes.container}>
                <div className={classes.title}>
                    <Text typography={TextTypography.PARA_ACCENT}>{t('vendor:dashboard.stepsWidget.sticker')}</Text>
                </div>
                <div>
                    <Text typography={TextTypography.BODY}>{t('vendor:dashboard.stepsWidget.stickerInfo')}</Text>
                </div>
                <div className={classes.title}>
                    <Text typography={TextTypography.PARA_ACCENT}>{t('vendor:dashboard.stepsWidget.online')}</Text>
                </div>
                <div>
                    <Text typography={TextTypography.BODY}>{t('vendor:dashboard.stepsWidget.onlineInfo')}</Text>
                </div>
                <div className={classes.title}>
                    <Text typography={TextTypography.PARA_ACCENT}>{t('vendor:dashboard.stepsWidget.social')}</Text>
                </div>
                <div>
                    <Text typography={TextTypography.BODY}>{t('vendor:dashboard.stepsWidget.socialInfo')}</Text>
                </div>
                <div className={classes.title}>
                    <Text typography={TextTypography.PARA_ACCENT}>{t('vendor:dashboard.stepsWidget.visibility')}</Text>
                </div>
                <div>
                    <Text typography={TextTypography.BODY}>{t('vendor:dashboard.stepsWidget.visibilityInfo')}</Text>
                </div>
                <div className={classes.title}>
                    <Text typography={TextTypography.PARA_ACCENT}>
                        {t('vendor:dashboard.stepsWidget.freeShipping')}
                    </Text>
                </div>
                <div>
                    <Text typography={TextTypography.BODY}>{t('vendor:dashboard.stepsWidget.freeShippingInfo')}</Text>
                </div>
                <div className={classes.title}>
                    <Text typography={TextTypography.PARA_ACCENT}>{t('vendor:dashboard.stepsWidget.feedBack')}</Text>
                </div>
                <div>
                    <Text typography={TextTypography.BODY}>{t('vendor:dashboard.stepsWidget.feedBackInfo')}</Text>
                </div>
                <div className={classes.title}>
                    <Text typography={TextTypography.BODY}>{t('vendor:dashboard.stepsWidget.findMore')}</Text>
                </div>
            </div>
        </Dialog>
    );
};
